.container {
    margin-top: 8px;
    width: 100%;
}

/* ── OPTIONAL divider ── */
.divider {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 10px 0 14px;

    &::before,
    &::after {
        content: "";
        flex: 1;
        height: 1px;
        background: #c8c8c8;
    }
}

.dividerLabel {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #333;
    white-space: nowrap;
}

/* ── Addon card ── */
.addonCard {
    display: flex;
    align-items: center;
    gap: 14px;
    background: #F2F2F2;
    border: 1px solid #e2e2e2;
    border-radius: 10px;
    padding: 0 10px 0 0;

    overflow: hidden;
    position: relative;
    z-index: 1;


    &::before {
        z-index: 3;
        display: none;
    }

    &::after {
        content: '🏆Popular Item';
        position: absolute;
        top: -1px;
        right: -1px;
        color: #FFF;
        font-family: var(--font-family, 'sofia-pro, sans-serif');
        font-size: 10px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        border-radius: 0 5px;
        background: #D61E2D;
        display: inline-flex;
        padding: 1px 5px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        z-index: 1;
    }

    .priceRowContainer {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }

    .special_price_title {
        text-align: center;
        display: block;
        color: #2B2B2B;
        font-family: var(--font-family, 'sofia-pro, sans-serif');
        font-size: 10px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: 0.09px;
        text-transform: uppercase;
    }
}

.addonImage {
    width: 70px;
    height: 70px;
    object-fit: contain;
    border-radius: 6px;
    flex-shrink: 0;
}

.addonImagePlaceholder {
    width: 70px;
    height: 70px;
    background: #f0f0f0;
    border-radius: 6px;
    flex-shrink: 0;
}

@keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
}

.addonCardSkeleton {
    height: 70px;
    border-radius: 10px;
    background-color: #c8c8c8;
    margin-top: 8px;
    position: relative;
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.6) 50%, transparent 100%);
        transform: translateX(-100%);
        animation: shimmer 1.5s ease-in-out infinite;
    }
}

.addonInfo {
    flex: 1;
    min-width: 0;
}

.addonName {
    font-size: 16px;
    font-weight: 700;
    color: #1a1a1a;
    margin-bottom: 6px;
    line-height: 1.2;
}

/* ── Price row ── */
.priceRow {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    padding-inline: 3px;
    background-color: #fff;
    border-radius: 4px;
}

.comparePrice {
    font-size: 14px;
    color: #888;
    text-decoration: line-through;
}

.price {
    font-size: 16px;
    font-weight: 700;
    color: #d0021b;
}

.saveBadge {
    display: inline-block;
    background: #1a1a1a;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    padding: 1px 8px;
    line-height: 16px;
    border-radius: 4px;
    white-space: nowrap;
}

/* ── Toggle switch ── */
.toggle {
    position: relative;
    flex-shrink: 0;
    width: 52px;
    height: 28px;
    cursor: pointer;

    input {
        opacity: 0;
        width: 0;
        height: 0;
        position: absolute;
    }

    input:checked+.toggleSlider {
        background-color: #555;
    }

    input:checked+.toggleSlider::before {
        transform: translateX(24px);
    }
}

.toggleSlider {
    position: absolute;
    inset: 0;
    background-color: #ccc;
    border-radius: 28px;
    transition: background-color 0.2s;

    &::before {
        content: "";
        position: absolute;
        width: 22px;
        height: 22px;
        left: 3px;
        top: 3px;
        background-color: #fff;
        border-radius: 50%;
        transition: transform 0.2s;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
    }
}